var quiz = {
    questions: [{
        text: "Which one of the following steps is (are) NOT present in a genetic algorithm?",
        responses: [{
            text: "Selection",
            index: 'A'
          },
          {
            text: "Crossover",
            index: 'B'
          },
          {
            text: "Mutation",
            index: 'C'
          },
          {
            text: "All are present ",
            index: 'D',
            correct: true
          }
        ]
      },
      {
        text: "Arrange the following in the correct sequence of their occurrence in the context of genetic algorithm\r\n\r\n1.\tSelection\r\n2.\tMutation\r\n3.\tFitness Assignment\r\n4.\tCrossover\r\n5.\tInitialization\r\n",
        responses: [{
            text: "5, 2, 4, 1, 3",
            index: 'A'
          },
          {
            text: "5, 4, 3, 1, 2",
            index: 'B'
          },
          {
            text: "5, 1, 3, 4, 2",
            index: 'C',
          },
          {
            text: "5, 3, 1, 4, 2",
            index: 'D',
            correct: true
          }
        ]
      },
      {
        text: "Which among the following is (are) the termination condition(s) for the genetic algorithm?",
        responses: [{
            text: "No improvement in the population for over x iterations.",
            index: 'A',
          },
          {
            text: "Predefining an absolute number of generations for the algorithm.",
            index: 'B'
          },
          {
            text: "When the fitness function has reached a predefined value.",
            index: 'C'
          },
          {
            text: "All the above",
            index: 'D',
            correct: true
          }
        ]
      },
      {
        text: "What role do genetic algorithms play as an optimization tool?",
        responses: [{
            text: "These are described as a global search method that does not use gradient information.",
            index: 'A',
            correct: true
          },
          {
            text: "These are described as a local search method that use gradient information",
            index: 'B'
          },
          {
            text: "These are described as a local search method that does not use gradient information.",
            index: 'C',
          },
          {
            text: "None of these",
            index: 'D'
          }
        ]
      },
      {
        text: "Which among the following is (are) the crossover type(s) in genetic algorithm?",
        responses: [{
            text: "Cut and Splice",
            index: 'A'
          },
          {
            text: "Half Uniform Crossover",
            index: 'B'
          },
          {
            text: "Multi-point ",
            index: 'C'
          },
          {
            text: "All of the above ",
            index: 'D',
            correct: true
          }
        ]
      }
    ]
  },
  userResponseSkelaton = Array(quiz.questions.length).fill(null);
var $ = window.jQuery = require('jquery');
import VueCircle from 'vue2-circle-progress/src/index.vue'
import {
  bus
} from '../../main';
import Vue from 'vue'
export default {
  name: 'quiz-format',
  components: {
    VueCircle
  },
  props: [],
  data() {
    return {
      fill: {
        color: "#0cbfe9"
      },
      quiz: quiz,
      questionIndex: 0,
      userResponses: [],
      quizStarted: true,
      isActive: false,
      totalTime: 90,
      totalScore: 0,
      countDown: {
        minutes: "00",
        seconds: "00"
      }
    }
  },
  computed: {

  },
  mounted() {
    console.log("Quiz Machine Learing");
    var totalTime = new Date();
    totalTime.setSeconds(totalTime.getSeconds() + this.totalTime);
    this.initializeTimer(totalTime)
  },
  methods: {
    selectOption: function(index) {
      Vue.set(this.userResponses, this.questionIndex, index);
    },
    next: function() {
      if (this.questionIndex < this.quiz.questions.length) {
        this.questionIndex++;
        this.score()
      }
    },
    prev: function() {
      if (this.quiz.questions.length > 0) this.questionIndex--;
    },
    // Return "true" count in userResponses
    score: function() {
      var score = 0;
      for (let i = 0; i < this.userResponses.length; i++) {
        if (
          typeof this.quiz.questions[i].responses[
            this.userResponses[i]
          ] !== "undefined" &&
          this.quiz.questions[i].responses[this.userResponses[i]].correct
        ) {
          score = score + 1;
        }
      }
      this.totalScore = score;
      return score;
    },

    //   CountDown
    initializeTimer: function(endTime) {
      var _self = this;

      function updateClock() {
        let remainTime = _self.getTimeRemaining(endTime)
        _self.countDown = remainTime;
        _self.UpdatePercentage(remainTime.total);
        if (remainTime.total <= 0) {
          clearInterval(timeinterval);
        }
      }
      updateClock();
      var timeinterval = setInterval(updateClock, 1000);
    },
    getTimeRemaining(endTime) {
      var t = Date.parse(endTime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      return {
        'total': t,
        'minutes': minutes,
        'seconds': seconds
      };
    },
    UpdatePercentage(remainTime) {
      let totalTime = (this.totalTime) * 1000;
      let percentage = 100 - ((remainTime * 100) / totalTime)
      if (this.$refs.timerRef)
        this.$refs.timerRef.updateProgress(percentage);
    },
    showCategory() {
      $('.quizzort_popup_wrp').removeClass('popup_slide_active')
      setTimeout(() => {
        bus.$emit('showQuizGameMachineLearning', false);
      }, 500);
      setTimeout(() => {
        bus.$emit('hideQuizCategory', true);
      }, 500);
      setTimeout(() => {
      $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 600);
    },
    QuizGamePopupClose() {
      $(".quizzort_main_wrp").removeClass("popup_active");
      setTimeout(() => {
        bus.$emit('showQuizGameMachineLearning', false);
        bus.$emit('hideQuizzortPopupEnabled', false);
        $("body").removeClass("quizzort_popup_active");
      }, 500)
    }
  },
}